
import WaitObjectByPathPromise from "app/wait_object_by_path_promise"
import log from "plugins/loglevel/index"

const LOGGING_PREFIX = "App.Tracking.FacebookPixel.Event"

/*
 * Facebook pixel standard Events
 * We use some of the few Facebook standard events for tracking our leads
 * https://www.facebook.com/business/help/402791146561655
 *
 * We use the standard event `Lead` for tracking Phone Leads
*/
const trackPhone = () => {
  WaitObjectByPathPromise("fbq")
  .then((fbq) => fbq("track", "Lead"))
}

const trackEmail = () => {
  WaitObjectByPathPromise("fbq")
  .then((fbq) => fbq("track", "AddToCart"))
}


const track = ({category, name}: {category: string, name: string}) => {
  if (typeof category === "undefined"){
    log.debug("category missing!")
    return
  }

  if (typeof name === "undefined"){
    log.debug("name missing")
    return
  }

  const debug_message_fragments = [
    LOGGING_PREFIX,
    "about to track event with:",
    [
      `content_category: [${category}]`,
      `content_name: [${name}]`,
    ].join(" ,"),
  ]

  log.debug(debug_message_fragments.join(" "))

  WaitObjectByPathPromise("fbq")
  .then((fbq) => {
    fbq("track", "ViewContent", {
      content_name:     name,
      content_category: category,
    })
  })
}

// FB custom event doc:
// https://developers.facebook.com/docs/facebook-pixel/implementation/conversion-tracking#custom-events
const trackCustomEvent = (event_name: string) => {
  const debug_message_fragments = [
    LOGGING_PREFIX,
    "about to track event with:",
    [
      `event_name: [${event_name}]`,
    ].join(" ,"),
  ]

  log.debug(debug_message_fragments.join(" "))

  WaitObjectByPathPromise("fbq")
  .then((fbq) => {
    fbq("trackCustom", event_name)
  })
}

export default {
  trackPhone,
  trackEmail,
  track,
  trackCustomEvent,
}
